import { render, staticRenderFns } from "./DebtorCreditorAmount.vue?vue&type=template&id=089816e0&scoped=true&"
import script from "./DebtorCreditorAmount.vue?vue&type=script&lang=js&"
export * from "./DebtorCreditorAmount.vue?vue&type=script&lang=js&"
import style0 from "./DebtorCreditorAmount.vue?vue&type=style&index=0&id=089816e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089816e0",
  null
  
)

export default component.exports